<div class="row mt-4">
  @for (car of cars(); track car.id; let i = $index) {
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <app-car-item [car]="car" [listId]="listId()"></app-car-item>
    </div>
  }
</div>
